import React, { useState } from "react";
import Swal from "sweetalert2";
import ReLoginModal from "../components/ReLoginModal";
import "../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { useNavigate } from "react-router-dom";
import api from "../util/axios";

interface RefundDetails {
  amount: string;
  productId: string;
}

interface Product {
  _id: string;
  name: string;
}

interface RefundProps {
  handleRefund: () => void;
  customer: any;
  setRefund: React.Dispatch<React.SetStateAction<boolean>>;
}

const Refund: React.FC<RefundProps> = ({
  handleRefund,
  customer,
  setRefund,
}: any) => {
  const [reLogin, setReLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState<Product[]>([]);
  const [refundDetails, setRefundDetails] = useState<RefundDetails>({
    amount: "",
    productId: "",
  });
  const [customerAccountId, setCustomerAccountId] = useState("");

  const token = window.localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const navigate = useNavigate();

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setRefundDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleAccountProducts = (e: any) => {
    const accountId = e.target.value;
    setCustomerAccountId(accountId);

    const account = customer.customerAccount.find(
      (acc: any) => acc._id === accountId
    );
    setProducts(account?.product || []);
  };

  console.log("customer account", customer.customerAccount);
  console.log("products", products);

  const handleRefundSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    api
      .patch(
        `/customer/${customerAccountId}/refund`,
        refundDetails,
        { headers: headers }
      )
      .then((res) => {
        Swal.fire({
          title: "Success!",
          text: res.data.message,
          icon: "success",
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        setLoading(false);
        setRefund(false);
        navigate(-1); // Go back to previous page
      })
      .catch((err) => {
        Swal.fire({
          title: "Error!",
          text: err.response.data.message,
          icon: "error",
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
        setLoading(false);
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
      });
  };

  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Refund</h4>
          <ImCancelCircle
            className="catCancel"
            onClick={() => {
              handleRefund();
              navigate("/dashboard/customer");
            }}
          />
        </div>
        {reLogin && <ReLoginModal />}
        <div className="line"></div>
        <form onSubmit={handleRefundSubmit} className="invoiceTable">
          <div className="catModalInput branchInput noM">
            <select
              name="customerAccountId"
              onChange={handleAccountProducts}
              value={customerAccountId}
            >
              <option value="">Select Account</option>
              {customer.customerAccount.map((account: any) => (
                <option key={account._id} value={account._id}>
                  {account.bank?.bankName}
                </option>
              ))}
            </select>
            <input
              type="text"
              placeholder="Amount"
              name="amount"
              value={refundDetails.amount}
              onChange={handleInputChange}
            />
            {customerAccountId && (
              <select
                name="productId"
                onChange={handleInputChange}
                value={refundDetails.productId}
              >
                <option value="">Select Product</option>
                {products.map((product) => (
                  <option key={product._id} value={product._id}>
                    {product.name}
                  </option>
                ))}
              </select>
            )}
            <div className="crBtn sstest">
              <button type="submit" disabled={loading}>
                {loading ? "Processing..." : "Submit Refund"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Refund;
